import { render, staticRenderFns } from "./SelectBackhaulStatus.vue?vue&type=template&id=5b1ff398"
import script from "./SelectBackhaulStatus.vue?vue&type=script&lang=js"
export * from "./SelectBackhaulStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports